module.exports = __webpack_public_path__ + "static/media/09.231be028.jpg";